jQuery(document).on('ready', () => {
    OFFER.bp = 768;
    OFFER.onReady();
    OFFER.onResize();
});

var OFFER = {
    onReady: () => {
        if ( jQuery('#form-offer').length < 1 )
            return;

        OFFER.context = '[data-validate="pristine"]';

        OFFER.initPristine();
        jQuery(OFFER.context).on('submit', OFFER.initSubmit);
        
        jQuery('#form-offer .webshops').hide();
        jQuery('#form-offer .webshop').hide();
        jQuery('#form-offer .control.participants input').prop('checked', false);
        jQuery('#form-offer .control.countries select[name=rtx-country] option:selected').prop('selected', false);

        jQuery('#form-offer input.participant').on('change', OFFER.changeParticipant );
        jQuery('#form-offer select[name=rtx-country]').on('change', OFFER.changeCountry );

        OFFER.changeParticipant();
        OFFER.changeCountry();
    },



    onResize: () => {
        jQuery(window).on('resize orientationChange', () => {
            // BASE.placeLangNav();
            
        });
    },



    initPristine: () => {
        Pristine.setLocale('de');
        Pristine.addMessages('de', snJS.pristineLang);
        

        OFFER.pristineConfig = {
            classTo: 'control',
            errorClass: 'is-danger',
            successClass: false,
            errorTextParent: 'control',
            errorTextClass: 'help is-danger'
        };

        const $form = jQuery(OFFER.context);
        
        jQuery.each($form, function(i,v){
            new Pristine(v, OFFER.pristineConfig);
        });
    },



    initSubmit: () => {
        OFFER.formname = jQuery('input[name=rtx-form-name]', OFFER.context).val();
        OFFER.form     = jQuery(OFFER.context).get(0);

        let pristine = new Pristine(OFFER.form, OFFER.pristineConfig);

        jQuery('[data-validate-message]').addClass('is-hidden');

        
        if ( pristine.validate() ) {
            jQuery(OFFER.context).find('#rtx-submit').addClass('is-loading');
            OFFER.sendForm();

            jQuery.each( jQuery('input.participant:checked', OFFER.context), (i, v) => {
                TRACKING.sendGA4event(
                                        'apply_card', 
                                        {
                                            'contact_type'  : 'apply_card',
                                            'issuer'        : jQuery(v).val(),
                                            'country'       : jQuery('select.country option:selected', OFFER.context).val(),
                                            'language'      : snJS.lang 
                                        }
                                    );
            });
        }

        return false;
    },



    sendForm: () => {
        var formData = jQuery(OFFER.context).serialize();
        var formOffset = jQuery(OFFER.context).parent().find('.notification').offset();

        jQuery.ajax({
            type: 'POST',
            url: snJS.ajaxurl,
            data: 'action=submitformoffer&' + formData,
            success: function (response, textStatus, XMLHttpRequest) {
                var regex    = new RegExp(/[0]$/);
                var response = jQuery.trim(response.replace(regex, ''));

                // console.log(response);

                jQuery('.notification').addClass('is-hidden');
                jQuery('.notification[data-validate-message="' + response + '"]').removeClass('is-hidden');

                if ( response == 'success' )
                    jQuery(OFFER.context).slideUp(200);
                
                
                jQuery('html, body').animate({scrollTop: formOffset.top - 0}, 500);
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                console.log('Server error: ' + errorThrown);
            }
        });
    },



    changeParticipant: () => {
        OFFER.participant = jQuery('#form-offer input.participant:checked').val();
        
        OFFER.selectParticipant();
        OFFER.showWebshop();
        OFFER.showForm();
    },



    changeCountry: () => {
        OFFER.country = jQuery('#form-offer .countries select[name=rtx-country] option:selected').val();

        OFFER.showWebshop();
        OFFER.showForm();
    },



    selectParticipant: () => {
        jQuery("#form-offer .countries select[name=rtx-country] option:selected").removeAttr("selected");

        if ( OFFER.participant != '' ){
            jQuery('#form-offer .countries select[name=rtx-country] option').hide();
            jQuery('#form-offer .countries select[name=rtx-country] option.has-' + OFFER.participant).show();
        } else {
            jQuery('#form-offer .countries select[name=rtx-country] option').show();
        }
    },



    showWebshop: () => {
        jQuery('#form-offer .webshops').hide();
        if ( OFFER.participant && OFFER.country ) {
            jQuery('#form-offer .webshop')
                .hide()
                .removeClass('is-active');

            // jQuery.each(OFFER.participant, (i,v) => {
                jQuery('#form-offer .webshop.' + OFFER.participant + '.' + OFFER.country)
                    .fadeIn()
                    .addClass('is-active'); 
            // });
            
            if ( jQuery('#form-offer .webshops .webshop.is-active').length >= 1)
                jQuery('#form-offer .webshops').show();
        }
    },



    showForm: () => {
        if ( OFFER.participant && OFFER.country )
            jQuery('#form-offer .form').fadeIn();
    }
}